import React, { useState, useEffect } from "react";
import * as Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import moment from "moment";
import {
  addDays,
  CompareDate,
  getDiffBtnDates,
} from "../../utils/dateCalculater";

const StockBarChart = ({ anltcs }) => {
  const [graphView, getGraphView] = useState("daily");
  const [SBCData, setSBCData] = useState({
    catagry: [],
    ordr: [],
    trade: [],
  });

  const [sortedOrdsPrDay, setSortedOrdsPrDay] = useState([
    // { key: "2020-10-21", val: "10" },
    // { key: "2020-10-27", val: "10" },
    // { key: "2020-10-29", val: "10" },
    // { key: "2020-11-06", val: "10" },
    // { key: "2020-11-20", val: "10" },
    // { key: "2020-11-29", val: "10" },
    // { key: "2020-11-30", val: "15" },
    // { key: "2020-12-15", val: "15" },
  ]);
  const [sortedTrdsPrDay, setSortedTrdsPrDay] = useState([
    // { key: "2020-10-21", val: "10" },
    // { key: "2020-10-27", val: "10" },
    // { key: "2020-10-29", val: "10" },
    // { key: "2020-11-20", val: "10" },
    // { key: "2020-11-29", val: "10" },
    // { key: "2020-11-30", val: "15" },
    // { key: "2020-12-15", val: "15" },
    // { key: "2020-12-16", val: "15" },
    // { key: "2020-12-17", val: "15" },
  ]);

  const heandelGraphView = (view) => {
    getGraphView(view);
  };

  const setUpChart = async () => {
    if (graphView === "weekly") {
      let firstDate =
        sortedOrdsPrDay && sortedTrdsPrDay
          ? CompareDate(
              sortedOrdsPrDay[0].key,
              sortedTrdsPrDay[0].key,
              "smallerDate"
            )
          : "";

      let lastDate =
        sortedOrdsPrDay && sortedTrdsPrDay
          ? CompareDate(
              sortedOrdsPrDay[sortedOrdsPrDay.length - 1].key,
              sortedTrdsPrDay[sortedTrdsPrDay.length - 1].key,
              "biggerDate"
            )
          : "";

      // let firstDate = SBCData.catagry[0];
      // let lastDate = SBCData.catagry[SBCData.catagry.length - 1];

      let totalWeeks = await getDiffBtnDates(firstDate, lastDate);
      if (totalWeeks % 1 !== 0) {
        totalWeeks = parseInt(totalWeeks.toFixed(0)) + 1;
      }

      console.log(firstDate);
      console.log(lastDate);
      let getOrderData = [...sortedOrdsPrDay];
      let getTradeData = [...sortedTrdsPrDay];

      let catagry = [];
      let ordrData = [];
      let trad = [];

      let dateOne = firstDate;
      for (let i = 0; i <= totalWeeks; i++) {
        let seventhDay = await addDays(dateOne, 6);

        let customOrderData = getOrderData.filter((date) => {
          return (
            date.key >= moment(dateOne).format("YYYY-MM-DD") &&
            date.key <= moment(seventhDay).format("YYYY-MM-DD")
          );
        });

        let customTradeData = getTradeData.filter((date) => {
          return (
            date.key >= moment(dateOne).format("YYYY-MM-DD") &&
            date.key <= moment(seventhDay).format("YYYY-MM-DD")
          );
        });

        if (customOrderData.length > 0) {
          let sumOfOrder = 0;
          for (let i = 0; i < customOrderData.length; i++) {
            sumOfOrder += parseInt(customOrderData[i].val);
          }

          ordrData.push(sumOfOrder);
        } else {
          if (dateOne <= lastDate) {
            ordrData.push(0);
          }
        }

        if (customTradeData.length > 0) {
          let sumOfTrade = 0;
          for (let i = 0; i < customTradeData.length; i++) {
            sumOfTrade += parseInt(customTradeData[i].val);
          }
          trad.push(sumOfTrade);
        } else {
          if (dateOne <= lastDate) {
            trad.push(0);
          }
        }
        console.log(moment(dateOne).format("YYYY-MM-DD"), lastDate);
        if (dateOne <= lastDate) {
          catagry.push(
            `${moment(dateOne).format("YYYY-MM-DD")} to ${moment(
              seventhDay
            ).format("YYYY-MM-DD")}`
          );
        }

        dateOne = await addDays(seventhDay, 1);
      }

      if (catagry.length > 0 || ordrData.length > 0 || trad.length > 0) {
        console.log(catagry);
        console.log(ordrData);
        console.log(trad);

        setSBCData({
          catagry: catagry,
          ordr: [...ordrData],
          trade: [...trad],
        });
      }
    } else {
      let catagry = [];
      let ordrData = [];
      let trad = [];

      //  adding date in catagry of both sortedOrdsPrDay and sortedTrdsPrDay
      sortedOrdsPrDay.forEach((ord) => {
        catagry.push(ord.key);
      });
      sortedTrdsPrDay.forEach((trd) => {
        if (!catagry.includes(trd.key)) {
          catagry.push(trd.key);
        }
      });

      catagry.sort();

      // checking if data available for catagry's date then add data otherwise add 0
      if (catagry.length > 0) {
        catagry.forEach((cat) => {
          if (sortedTrdsPrDay.some((trd) => trd.key === cat)) {
            let getTrade = sortedTrdsPrDay.filter((sortTrd) => {
              return sortTrd.key === cat;
            });
            trad.push(parseInt(getTrade[0].val));
          } else {
            trad.push(0);
          }

          if (sortedOrdsPrDay.some((ord) => ord.key === cat)) {
            let getOrder = sortedOrdsPrDay.filter((sortOrd) => {
              return sortOrd.key === cat;
            });
            ordrData.push(parseInt(getOrder[0].val));
          } else {
            ordrData.push(0);
          }
        });
      }

      if (catagry.length > 0 || ordrData.length > 0 || trad.length > 0) {
        setSBCData({
          catagry: catagry,
          ordr: [...ordrData],
          trade: [...trad],
        });
      }
    }
  };

  useEffect(() => {
    if (
      (sortedOrdsPrDay && sortedOrdsPrDay.length > 0) ||
      (sortedTrdsPrDay && sortedTrdsPrDay.length > 0)
    ) {
      setUpChart();
    }
  }, [sortedOrdsPrDay, sortedTrdsPrDay, graphView]);

  useEffect(() => {
    if (anltcs && (anltcs.ordsPrDay || anltcs.trdsPrDay)) {
      let sortedOrder = anltcs.ordsPrDay.sort(function (a, b) {
        return new Date(a.key) - new Date(b.key);
      });
      let sortedTrade = anltcs.trdsPrDay.sort(function (a, b) {
        return new Date(a.key) - new Date(b.key);
      });
      setSortedOrdsPrDay(sortedOrder);
      setSortedTrdsPrDay(sortedTrade);
    } else {
      setSortedOrdsPrDay([]);
      setSortedTrdsPrDay([]);
      setSBCData({
        catagry: [],
        ordr: [],
        trade: [],
      });
    }
  }, [anltcs]);

  const options = {
    chart: {
      type: "column",
      height: "300px",
    },
    title: {
      text: null,
    },
    credits: {
      enabled: false,
    },
    legend: {
      symbolRadius: 2,
    },
    colors: ["#1c9ad6", "#f7943e"],
    xAxis: {
      categories: [...SBCData.catagry],
      labels: {
        formatter: function () {
          if (this.value.includes("to")) {
            let splitVal = this.value.split("to");
            console.log(splitVal);
            return `${moment(splitVal[0]).format("DD MMM 'YY")} - ${moment(
              splitVal[1]
            ).format("DD MMM 'YY")}`;
          } else {
            return moment(this.value).format("DD MMM 'YY"); // clean, unformatted number for year
          }
        },
      },
      crosshair: true,
    },
    yAxis: {
      min: 0,
      gridLineWidth: 1,
      title: "null",
      labels: {
        formatter: function () {
          let val = this.value;
          if (val >= 10000000) {
            val = (val / 10000000).toFixed(0) + "Cr";
          } else if (val >= 100000) {
            val = (val / 100000).toFixed(0) + "L";
          } else if (val >= 1000) {
            val = (val / 1000).toFixed(0) + "K";
          }
          return val;
        },
      },
    },
    tooltip: {
      formatter: function () {
        let tooltipVal = "";
        if (this.points[0].x.includes("to")) {
          let splitVal = this.points[0].x.split("to");
          tooltipVal = `${moment(splitVal[0]).format("DD MMM 'YY")} - ${moment(
            splitVal[1]
          ).format("DD MMM 'YY")}`;
        } else {
          tooltipVal = moment(this.points[0].x).format("DD MMM 'YY");
        }

        return `<b><p className="gray">${tooltipVal}</p>
          </br>
          <p className="gray" style="color:${
            this.points[0].color
          }">No. of Orders</p>  
          <p className="lable-data">: ${this.points[0].y}</p>
          </br>
          <p className="gray" style="color:${
            this.points[1].color
          }">No. of Trades</p>
          <p className="lable-data">: ${
            this.points[1] ? this.points[1].y : 0
          }</p>
          </b>
          `;
      },
      shared: true,
      crosshairs: true,
      backgroundColor: "white",
      borderColor: "white",
      borderRadius: 10,
      borderWidth: 0,
      padding: 10,
    },
    plotOptions: {
      column: {
        pointPadding: 0.2,
        borderWidth: 0,
      },
    },
    series: [
      {
        name: "No. of Orders",
        data: [...SBCData.ordr],
      },
      {
        name: "No. of Trades",
        data: [...SBCData.trade],
      },
    ],
  };

  return (
    <>
      {(sortedOrdsPrDay.length > 0 || sortedTrdsPrDay.length > 0) && (
        <div className="chartSection">
          <div className="head display-space-between">
            <div>
              <h6>No. of Orders V/s Trades</h6>
            </div>
            <div className="period">
              <button
                className={
                  graphView === "daily"
                    ? "light-blue-btn pointer active"
                    : "light-blue-btn pointer"
                }
                onClick={() => heandelGraphView("daily")}
              >
                Daily
              </button>
              <button
                className={
                  graphView === "weekly"
                    ? "light-blue-btn pointer active"
                    : "light-blue-btn pointer"
                }
                onClick={() => heandelGraphView("weekly")}
              >
                Weekly
              </button>
            </div>
          </div>
          <div className="GraphChart">
            <HighchartsReact highcharts={Highcharts} options={options} />
          </div>
        </div>
      )}
    </>
  );
};

export default StockBarChart;
